// Genesis design-token constants for the customer portal.
//
// Mirrors ui/src/index.css's --theme-* / Genesis Design Tokens table
// (.claude/skills/atf-ee/references/genesis.md) as plain values, since this
// app has no runtime --theme-* CSS-variable system like ui/ (ADR-179 kept
// this app dependency-light -- no @atfai/ui, no ThemeProvider). Every
// color/spacing/radius constant a shell or route needs lives here so
// routes stop hand-rolling neutral-800/steel-blue literals inline.
//
// Three-surface UI alignment pass (CL-2026-08-31 series, three-surface-ui-
// alignment): consolidates what login.tsx (#3337) proved out per-file into
// one importable module used by RootLayout + every route.

export const GOLD = '#D4B85C'
export const GOLD_LIGHT = '#D4BC72'
export const GOLD_DIM = 'rgba(212, 184, 92, 0.15)'
export const GOLD_BORDER = 'rgba(212, 184, 92, 0.12)'

export const CHARCOAL = '#18171A'
export const DARK = '#21201F'
export const SURFACE = '#2A2926'

export const SUCCESS = '#4ADE80'
export const WARNING = '#FBBF24'
export const DANGER = '#F27B76'
export const INFO = '#60A5FA'

export const WHITE = '#F5F4F0'
export const GREY_100 = '#E8E7E2'
export const GREY_200 = '#D4D3CE'
export const GREY_300 = '#B0AFA8'
export const GREY_400 = '#6E6D68'
export const GREY_500 = '#4A4944'

// Glass-card idiom (ui/src/index.css .glass-card): translucent surface +
// blur + soft shadow. This app has no backdrop token, so the values are
// inlined directly on DARK at reduced opacity for the same visual effect.
export const glassCardStyle: React.CSSProperties = {
  backgroundColor: 'rgba(33, 32, 31, 0.72)',
  backdropFilter: 'blur(16px) saturate(140%)',
  WebkitBackdropFilter: 'blur(16px) saturate(140%)',
  border: `1px solid ${GOLD_BORDER}`,
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.35)',
}

export const glassInputStyle: React.CSSProperties = {
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  border: `1px solid ${GREY_500}`,
  borderRadius: '8px',
}

// Status badge colors (Genesis "Status Badges" table) keyed by semantic
// name so callers don't re-derive tone-to-hex mappings per file.
export const STATUS_COLOR: Record<'success' | 'warning' | 'danger' | 'idle' | 'info' | 'gold', string> = {
  success: SUCCESS,
  warning: WARNING,
  danger: DANGER,
  idle: GREY_400,
  info: INFO,
  gold: GOLD,
}

// Error block (Genesis "Error Design"): 3px red left border on a dark
// card, NEVER red text. Every error/failure banner in this app should
// spread this rather than hand-rolling the border+color pair.
export const errorBlockStyle: React.CSSProperties = {
  backgroundColor: DARK,
  borderLeft: `3px solid ${DANGER}`,
  borderRadius: '8px',
}

// Primary gold button (Genesis "Buttons" table: 42px h, 8px radius, dark text).
export const primaryButtonStyle: React.CSSProperties = {
  backgroundColor: GOLD,
  color: CHARCOAL,
  height: '42px',
  borderRadius: '8px',
}

// Compact primary button variant for inline table/row actions (32px h).
export const primaryButtonCompactStyle: React.CSSProperties = {
  backgroundColor: GOLD,
  color: CHARCOAL,
  height: '32px',
  borderRadius: '8px',
}
